module.exports = __webpack_public_path__ + "static/media/tabaka-hosp.a16fe9e7.jpg";